// extracted by mini-css-extract-plugin
export var main = "index-module--main--2b2X7";
export var text = "index-module--text--39IJG";
export var controlButtons = "index-module--control-buttons--3Tnni";
export var controlButton = "index-module--control-button--kEyCA";
export var icons = "index-module--icons--3SDUU";
export var imageWrapper = "index-module--image-wrapper--1TGUb";
export var webPreviewWrapper = "index-module--web-preview-wrapper--Bayfd";
export var visible = "index-module--visible--3W_NI";
export var webPreview = "index-module--web-preview--2Lbu6";